/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function ChevronWideIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 25 24'
      {...props}
    >
      <path
        fill='#D5D8DC'
        d='m22.123 8-10 10-10-10 1.775-1.775 8.225 8.225 8.225-8.225z'
      />
    </svg>
  )
}
